// extracted by mini-css-extract-plugin
export default {"container":"ContactList_container__HvdwK"};